import { IndexTable, Text, Thumbnail } from '@shopify/polaris';
import { useCurrency } from '../hooks/useCurrency';

export interface ProductRow {
  shopify_product_id: number;
  title: string;
  product_type?: string;
  vendor?: string;
  default_cost?: number | string | null;
  image_thumbnail?: string | null;
}

/**
 * Products table with cost/margin columns. PLAN.md §7.2.
 */
export default function ProductTable({
  products,
  currency = 'USD',
  onSelect,
}: {
  products: ProductRow[];
  currency?: string;
  onSelect?: (product: ProductRow) => void;
}) {
  const { formatMoney } = useCurrency(currency);

  const rowMarkup = products.map((product, index) => (
    <IndexTable.Row
      id={String(product.shopify_product_id)}
      key={product.shopify_product_id}
      position={index}
      onClick={() => onSelect?.(product)}
    >
      <IndexTable.Cell>
        {product.image_thumbnail ? (
          <Thumbnail source={product.image_thumbnail} alt={product.title} size="small" />
        ) : null}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" fontWeight="semibold" as="span">
          {product.title}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>{product.product_type ?? '—'}</IndexTable.Cell>
      <IndexTable.Cell>{product.vendor ?? '—'}</IndexTable.Cell>
      <IndexTable.Cell>
        {product.default_cost != null ? formatMoney(product.default_cost) : '—'}
      </IndexTable.Cell>
    </IndexTable.Row>
  ));

  return (
    <IndexTable
      itemCount={products.length}
      selectable={false}
      headings={[
        { title: '' },
        { title: 'Product' },
        { title: 'Type' },
        { title: 'Vendor' },
        { title: 'Default cost' },
      ]}
    >
      {rowMarkup}
    </IndexTable>
  );
}
